import { startCase } from 'lodash';

import { CurrencyType, PaymentTierUnit, ServiceType } from '@/gql/graphql';
import type { ListType } from '../models/app';

export const serviceTypeOptions: ListType[] = Object.values(ServiceType).map((service, index) => ({
  id: index + 1,
  key: service,
  label: startCase(service),
}));

export const paymentTierUnitOptions: ListType[] = Object.values(PaymentTierUnit).map((unit, index) => ({
  id: index + 1,
  key: unit,
  label: startCase(unit),
}));

export const currencyTypeOptions: ListType[] = Object.values(CurrencyType).map((currency, index) => ({
  id: index + 1,
  key: currency,
  label: currency.toUpperCase(),
}));

export const defaultPaymentTierUnitByService: Record<ServiceType, PaymentTierUnit> = {
  [ServiceType.Ride]: PaymentTierUnit.Minute,
  [ServiceType.Grocery]: PaymentTierUnit.Item,
  [ServiceType.Gourmet]: PaymentTierUnit.Item,
  [ServiceType.HomeService]: PaymentTierUnit.Hour,
  [ServiceType.PharmacyDelivery]: PaymentTierUnit.Item,
  [ServiceType.SpecialRequest]: PaymentTierUnit.Item,
};

export const cardImageList: {
  type: string;
  imgUrl: string;
}[] = [
  { type: 'MasterCard', imgUrl: 'http://icons.iconarchive.com/icons/designbolts/credit-card-payment/256/Master-Card-icon.png' },
  { type: 'Visa', imgUrl: 'http://icons.iconarchive.com/icons/custom-icon-design/flatastic-3/256/payment-creditcard-visa-icon.png' },
  { type: 'American Express', imgUrl: 'http://icons.iconarchive.com/icons/designbolts/credit-card-payment/128/American-Express-icon.png' },
  {
    type: 'Diners Club',
    imgUrl: 'http://icons.iconarchive.com/icons/designbolts/credit-card-payment/128/Diners-Club-International-icon.png',
  },
  { type: 'Discover', imgUrl: 'http://icons.iconarchive.com/icons/designbolts/credit-card-payment/128/Discover-icon.png' },
  { type: 'JCB', imgUrl: 'http://icons.iconarchive.com/icons/iconshock/credit-card/128/jcb-icon.png' },
  { type: 'UnionPay', imgUrl: 'http://alllogos.ru/images/logotip-unionpay.png' },
  { type: 'Card', imgUrl: 'http://icons.iconarchive.com/icons/webiconset/application/128/Invoice-icon.png' },
];

export const supervisorRetentionOfferPresetList: ListType[] = [
  { id: 1, key: 'custom', label: 'Custom' },
  { id: 2, key: 'fullMembership', label: 'Full Membership Refund' },
  { id: 3, key: 'credit100', label: '$100 Credit' },
  { id: 4, key: 'credit50', label: '$50 Credit' },
  { id: 5, key: 'credit30', label: '$30 Credit' },
];

export type SupervisorRetentionOfferPresetKey = 'custom' | 'fullMembership' | 'credit100' | 'credit50' | 'credit30';

export const supervisorRetentionOfferPresetConfig: Record<
  Exclude<SupervisorRetentionOfferPresetKey, 'custom'>,
  { amount: number | null; expirationType: string; expirationValue: string }
> = {
  fullMembership: { amount: null, expirationType: 'months', expirationValue: '12' },
  credit100: { amount: 100, expirationType: 'months', expirationValue: '6' },
  credit50: { amount: 50, expirationType: 'months', expirationValue: '3' },
  credit30: { amount: 30, expirationType: 'months', expirationValue: '1' },
};

export const freeCreditsReasonList: ListType[] = [
  { id: 1, key: 'bad experience', label: 'Bad Experience' },
  { id: 1, key: 'customer sent in check', label: 'Customer Sent in Check' },
  { id: 2, key: 'gift card redemption', label: 'Gift Card Redemption' },
  { id: 3, key: 'home services', label: 'Home Services' },
  { id: 4, key: 'retention', label: 'Retention' },
  { id: 5, key: 'refund ride', label: 'Refund Ride' },
  { id: 6, key: 'refund gourmet', label: 'Refund Gourmet' },
  { id: 7, key: 'refund grocery', label: 'Refund Grocery' },
  { id: 8, key: 'other', label: 'Other' },
];
